module.exports = __webpack_public_path__ + "img/feedbck-icon.238b81e6.svg";